import { IUniversity } from '@/shared/models/api/university-model';
import { UniversityMapper } from '@/shared/mappings/university-mapper';

class UniversityService {
    private universityMapper = new UniversityMapper();

    constructor() {}
    
    public getUniversitiesByCountry = (language: string, isoCode: string, HttpService: any): Promise<any> => {
        return this.getUniversities(this.universitiesByCountryQuery(language, isoCode), HttpService)
    }

    public getUniversities = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.get(url).then((result: IUniversity[]) => {
                let mappedResults = result.map((university: IUniversity) => this.universityMapper.mapUniversity(university));
                resolve(mappedResults);
            }).catch((error: any) => {
                reject(error.msg)
            });
        })
    }

    public universitiesByCountryQuery = (language: string, isoCode: string): string => {
        return `/api/formdata/${language}/externalorganizations/?countryisocode=${isoCode}`
    }
}

export default new UniversityService();